import React, { useEffect, useState } from 'react';
import { Stack } from '@fluentui/react/lib/Stack';
import { Spinner } from '@fluentui/react/lib/Spinner';
import { Icon, IIconStyles } from '@fluentui/react/lib/Icon';
import { Separator } from '@fluentui/react/lib/Separator';
import AdminCalendar from './AdminCalendar';
import { DefaultButton, PrimaryButton, ScrollablePane } from '@fluentui/react';
import { createNewGuid } from '../../../../../components/Utils';
import { Calendar, CalendarHolidays } from '../../../../../api/generated/data-contracts';
import { ApiCalls } from '../../../../../api/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useConfigValuesState } from '../../../../../hooks/useConfigValue';
import { GET_CALENDARS } from '../../../../../constants/queryKeys';

interface AdminCalendarsProps {
    calendars: Calendar[];
}

function AdminCalendars(props: AdminCalendarsProps) {
    // const uiCtx = useUiContext();

    const [calendars, setCalendars] = useState<Calendar[]>([]);
    const [isDefaultChanged, setIsDefaultChanged] = useState<number>(0);

    useEffect(() => {
        const sortedCalendars = props.calendars
            .toSorted((a, b) => Number(b.isDefault) - Number(a.isDefault) || a.name.localeCompare(b.name))
            .map(cal => ({
                ...cal,
                holidays: cal.holidays ? cal.holidays.toSorted((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()) : [],
            }));
        setCalendars(sortedCalendars);
    }, [props.calendars]);

    const RemoveCalendar = (c: Calendar) => {
        setCalendars(calendars.filter(cal => cal.id != c.id));
    };

    const IsDefaultChanged = () => {
        setIsDefaultChanged(isDefaultChanged + 1);
    };

    const CalendarUpdated = (id: string, name: string, language: string, isDefault: boolean, holidays: CalendarHolidays[]) => {
        let boolIsDefaultUpdated = false;
        const updatedCals = calendars;
        for (let i = 0; i < updatedCals.length; i++) {
            if (updatedCals[i].id == id) {
                updatedCals[i].name = name;
                updatedCals[i].language = language;
                updatedCals[i].isDefault = isDefault;
                updatedCals[i].holidays = holidays;
            }
            if (updatedCals[i].id != id && isDefault == true) {
                updatedCals[i].isDefault = false;
                boolIsDefaultUpdated = true;
            }
        }
        setCalendars(updatedCals);
        if (boolIsDefaultUpdated) {
            IsDefaultChanged();
        }
    };

    const { mutate, isLoading } = useMutation({
        mutationFn: () => {
            return ApiCalls.setCalendars(calendars);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [GET_CALENDARS] });
        },
    });

    const queryClient = useQueryClient();

    const saveChanges = () => {
        mutate();
        const sortedCalendars = calendars
            .toSorted((a, b) => Number(b.isDefault) - Number(a.isDefault) || a.name.localeCompare(b.name))
            .map(cal => ({
                ...cal,
                holidays: cal.holidays ? [...cal.holidays].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()) : [],
            }));
        setCalendars(sortedCalendars);
    };
    const AddCalendarClick = () => {
        const newCalendar: Calendar = { id: createNewGuid(), name: 'New Calendar', language: 'N/A', isDefault: false, holidays: [] };
        setCalendars(prevState => [...prevState, newCalendar]);
    };

    const {
        initialData: {
            aggregatedUser: { originalUser },
        },
    } = useConfigValuesState();
    return (
        <div style={outerDivStyle}>
            <ScrollablePane style={outerDivStyle}>
                <h3 style={{ marginTop: 20 }}>Calendars</h3>
                <Separator>
                    <Icon iconName="ProjectCollection" styles={separatorIconStyles} />
                </Separator>
                <br />
                {isLoading ? (
                    <Stack className="logindialog" horizontalAlign="center" verticalAlign="center">
                        <Spinner label="Loading..." />
                    </Stack>
                ) : (
                    <>
                        {originalUser.isAdmin && isDefaultChanged > -1 ? (
                            <div style={{ display: 'inline-block' }}>
                                <Stack tokens={{ childrenGap: 10 }}>
                                    {calendars.map((calendar, index) => {
                                        return (
                                            <AdminCalendar
                                                key={index}
                                                Calendar={calendar}
                                                IsDefault={calendar.isDefault}
                                                RemoveCalendar={RemoveCalendar}
                                                CalendarUpdated={CalendarUpdated}
                                            /> // IsDefaultChanged={IsDefaultChanged} />
                                        );
                                    })}
                                    <Separator>
                                        <Stack tokens={{ childrenGap: 10 }}>
                                            <Stack.Item align="center">
                                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                    <DefaultButton text="Add Calendar" onClick={AddCalendarClick} />
                                                    <PrimaryButton onClick={saveChanges} text="Save Calendars" />
                                                </Stack>
                                            </Stack.Item>
                                        </Stack>
                                    </Separator>
                                </Stack>
                                <br />
                                <br />
                                <br />
                            </div>
                        ) : (
                            <div style={personaAprroverConfigContainerDivStyle}>
                                <h3>Access Denied.</h3>
                            </div>
                        )}
                    </>
                )}
            </ScrollablePane>
        </div>
    );
}

export default AdminCalendars;

const outerDivStyle = {
    margin: '50px 0px 0px 0px',
    display: 'block',
    justifyContent: 'center',
    textAlign: 'center',
    // backgroundColor: 'white',
} as React.CSSProperties;

const personaAprroverConfigContainerDivStyle = {
    display: 'inline-flex',
};

const separatorIconStyles: IIconStyles = {
    root: {
        fontSize: '24px',
        height: '24px',
        width: '24px',
    },
};
